import { STATIC_DATA_TYPE } from "./static-data.enum";

export const TABLES: {key: STATIC_DATA_TYPE, displayValue: string, permittedForRoles?: string[]}[] = [
  {
    key: STATIC_DATA_TYPE.PAYOFFS,
    displayValue: 'Payoffs',
  },
  {
    key: STATIC_DATA_TYPE.CAPITAL_PROTECTION,
    displayValue: 'Capital Protection',
  },
  {
    key: STATIC_DATA_TYPE.UKSPA_CODES,
    displayValue: 'UKSPA Product Codes',
  },
  {
    key: STATIC_DATA_TYPE.UNDERLYINGS,
    displayValue: 'Underlyings',
  },
  {
    key: STATIC_DATA_TYPE.ISSUERS,
    displayValue: 'Issuer Reference Data',
  },
  {
    key: STATIC_DATA_TYPE.LANGUAGE,
    displayValue: 'Languages'
  },
  {
    key: STATIC_DATA_TYPE.CREDIT_RATING_DESCRIPTIONS,
    displayValue: 'Credit Ratings',
  },
  {
    key: STATIC_DATA_TYPE.CREDIT_RATING_OUTLOOKS,
    displayValue: 'Credit Outlooks',
  },
  {
    key: STATIC_DATA_TYPE.DEFAULT_RISK_DESCRIPTIONS,
    displayValue: 'Default Risk Probabilities',
  },
  {
    key: STATIC_DATA_TYPE.TRADING_CALENDARS,
    displayValue: 'Trading Calendars',
  },
  {
    key: STATIC_DATA_TYPE.SETTLEMENT_CALENDARS,
    displayValue: 'Settlement Calendars',
  },
  {
    key: STATIC_DATA_TYPE.TARGET_MARKETS,
    displayValue: 'Target Markets',
  },
  {
    key: STATIC_DATA_TYPE.REFERENCE_ENTITY,
    displayValue: 'Reference Entities',
  },
  {
    key: STATIC_DATA_TYPE.REFERENCE_OBLIGATION,
    displayValue: 'Reference Obligations',
  },
  {
    key: STATIC_DATA_TYPE.AGENTS,
    displayValue: 'Agents',
  },
  {
    key: STATIC_DATA_TYPE.CURRENCIES,
    displayValue: 'Currencies'
  },
  {
    key: STATIC_DATA_TYPE.ISSUERS_ENTITY,
    displayValue: 'Issuers',
  },
  {
    key: STATIC_DATA_TYPE.LEGAL_PROGRAMMES,
    displayValue: 'Legal Programmes',
  },
  {
    key: STATIC_DATA_TYPE.LISTING_VENUES,
    displayValue: 'Listing Venues',
  },
  {
    key: STATIC_DATA_TYPE.PHYSICAL_SETTLEMENT_MATRIX,
    displayValue: 'Physical Settlement Matrix',
  },
  {
    key: STATIC_DATA_TYPE.UNDERLYING_ASSETS,
    displayValue: 'Underlying Assets',
  },
  {
    key: STATIC_DATA_TYPE.EXCHANGES,
    displayValue: 'Exchanges',
  },
  {
    key: STATIC_DATA_TYPE.DATA_INGESTION_CONFIG,
    displayValue: 'Data Ingestion',
    permittedForRoles: ['V2_ADMINISTRATOR'],
  },
  {
    key: STATIC_DATA_TYPE.DATA_EXPORT_FORMATS,
    displayValue: 'Data Export Formats',
    permittedForRoles: ['V2_ADMINISTRATOR'],
  },
  {
    key: STATIC_DATA_TYPE.DESKS,
    displayValue: 'Desks',
  },
  {
    key: STATIC_DATA_TYPE.CONTACTS,
    displayValue: 'Contact Profiles',
  },
  {
    key: STATIC_DATA_TYPE.HURDLES_AND_SPREADS,
    displayValue: 'Hurdles and Spreads',
    permittedForRoles: ['V2_PRODUCT_GOVERNANCE_SUPERVISOR'],
  },
  {
    key: STATIC_DATA_TYPE.DISTRIBUTOR_GROUPS,
    displayValue: 'Distributor Groups',
  },
  {
    key: STATIC_DATA_TYPE.DISTRIBUTORS,
    displayValue: 'Distributors',
  },
  {
    key: STATIC_DATA_TYPE.LEGAL_ENTITY,
    displayValue: 'Legal Entities',
  },
  {
    key: STATIC_DATA_TYPE.BENEFIT_KEY,
    displayValue: 'Benefit Keys'
  },
  {
    key: STATIC_DATA_TYPE.PRODUCT_SUB_TYPE,
    displayValue: 'Products Sub Types',
  },
  {
    key: STATIC_DATA_TYPE.DATA_DICTIONARY,
    displayValue: 'Data Dictionary',
  },
  {
    key: STATIC_DATA_TYPE.RECURRING_FEE,
    displayValue: 'Recurring Fees Config',
  },
];
